import React from "react";
import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import spreetailImage from "../../images/Spreetail_Logo.png";
const AuthNavbar = () => {
  const navigate = useNavigate();
  const handleLogin = () => {
    navigate("/auth/login");
  };
  const handleRegister = () => {
    navigate("/auth/register");
  };

  return (
    <div>
      <AppBar position='static'>
        <Toolbar
          style={{
            display: "flex",
            justifyContent: "flex-start",
            backgroundColor: "#ffff",

            marginX: "auto",
            paddingX: "200px"
          }}
        >
          <img
            src={spreetailImage}
            alt="Spreetail Logo"
            style={{
              height: "60px",
            }}
          />
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default AuthNavbar;
